import http from "./http";
import { warning } from "@alert";
// const baseUrl = process.env.REACT_APP_BASE_URL;

const request = async (
  method,
  baseUrl,
  url,
  token,
  data = null,
  params = null,
  options = {}
) => {
  try {
    const response = await http({
      method,
      url: baseUrl + url,
      data,
      params,
      ...options,
      headers: {
        Authorization: "Bearer " + token,
        ...(options.headers || {}),
      },
    });
    return response;
  } catch (err) {
    throw err;
  }
};

const auth_request = async (
  method,
  baseUrl,
  url,
  token,
  data = null,
  params = null,
  options = {}
) => {
  try {
    const response = await http({
      method,
      url: baseUrl + url,
      data,
      params,
      ...options,
      headers: {
        Authorization: "Bearer " + token,
        ...(options.headers || {}),
      },
    });
    return response;
  } catch (err) {
    // status = 403 顯示權限錯誤訊息
    if (err.response?.status) {
      //權限處理
      warning(1, 
        "權限不足 !", 
        "請使用有更高權限的帳號進行此操作",
        "我了解了"
      );
    }
    // throw err;
  }
};

export {
  // baseUrl,
  request,
  auth_request,
};
